import Navbar from './components/Navbar/Navbar';
import Home from './components/Home/Home';
import About from './components/About/About';
import Qualification from './components/Qualification/Qualification';
import Skills from './components/Skills/Skills';
import Work from './components/Work/Work';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import Certification from './components/Certification/Certification';
import './App.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function HomePage() {
  return (
    <div className="App">
      <Navbar />
      <main className="main">
        <Home />
        <About />
        <Qualification />
        <Skills />
        <Certification />
        <Work />
        <Contact />
        <Footer />
      </main>
    </div>
  );
}

export default HomePage;
